import PropTypes from 'prop-types';
import Icon from "../../../Icon/Icon";
import { FormattedMessage } from 'react-intl';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const acceptanceInfo = {
  accept: {
    text: /*#__PURE__*/_jsx(FormattedMessage, {
      id: "rIbqjm",
      description: "Accepting",
      defaultMessage: "Accepting referrals"
    }),
    icon: /*#__PURE__*/_jsx(Icon, {
      icon: "CheckCircle",
      color: "green",
      className: "mr-1 my-auto"
    })
  },
  deny: {
    text: /*#__PURE__*/_jsx(FormattedMessage, {
      id: "l8K7Nm",
      description: "not-accepting",
      defaultMessage: "Not accepting referrals"
    }),
    icon: /*#__PURE__*/_jsx(Icon, {
      icon: "TimesCircle",
      color: "red",
      className: "mr-1 my-auto"
    })
  }
};
function ProgramAcceptance(props) {
  const {
    receiving_referrals,
    status = ''
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    className: "flex mt-2 text-sm items-center",
    children: [receiving_referrals ? acceptanceInfo.accept.icon : acceptanceInfo.deny.icon, receiving_referrals ? acceptanceInfo.accept.text : acceptanceInfo.deny.text, " ", status && "(".concat(status, ")")]
  });
}
ProgramAcceptance.propTypes = {
  receiving_referrals: PropTypes.bool.isRequired,
  status: PropTypes.string
};
export default ProgramAcceptance;
//# sourceMappingURL=ProgramAcceptance.js.map